import React, { useEffect, useCallback } from 'react';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { printElements } from 'shared/helpers';

window.addEventListener('keydown', (e) => {
  const { key, ctrlKey, metaKey } = e;
  if (key === 'p' && (ctrlKey || metaKey)) {
    e.preventDefault();
  }
});

/**
 *
 * @param {Object} param0
 * @param {import('react').Ref<HTMLElement>[]} param0.fitElements
 */
export default function PrintButton({ fitElements }) {
  const _onClick = useCallback(() => {
    if (fitElements) {
      printElements(fitElements.map((e) => e.current));
    } else {
      window.print();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const eventListener = (e) => {
      const { key, ctrlKey, metaKey } = e;
      if (key === 'p' && (ctrlKey || metaKey)) {
        e.preventDefault();
        _onClick();
      }
    };
    window.addEventListener('keydown', eventListener);
    return () => {
      window.removeEventListener('keydown', eventListener);
    };
  }, [_onClick]);
  return (
    <button id='imprimir' onClick={_onClick}>
      <FontAwesomeIcon icon={faPrint} />
    </button>
  );
}
